import { Link } from "react-router-dom";
import { cameFromCta, clearCameFromCta } from "../fromCta";
import ConnectionStatusBadge from "./ConnectionStatusBadge";
import GpsStatusBadge from "./GpsStatusBadge";

interface FieldHeaderProps {
  projetoNome: string;
  connectionStatus: "online" | "offline" | "sincronizando" | "erro";
  gpsStatus: "capturado" | "indisponivel" | "buscando" | "baixa_precisao";
  precisaoGps?: number;
}

export default function FieldHeader({ projetoNome, connectionStatus, gpsStatus, precisaoGps }: FieldHeaderProps) {
  return (
    <header className="bg-white border-b border-[#E8EAED] sticky top-0 z-50">
      <div className="px-4 py-2.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5 min-w-0">
            {cameFromCta() && (
            <Link
              to="/cta"
              onClick={clearCameFromCta}
              className="h-8 px-2 rounded-lg border border-[#E8EAED] hover:bg-[#F4F5F7] flex items-center gap-1 text-xs font-medium text-[#3F4A52] flex-shrink-0"
              aria-label="Voltar ao CTA"
              title="Voltar ao CTA"
            >
              <i className="ri-arrow-left-line text-sm" />
              CTA
            </Link>
            )}
            <div className="w-8 h-8 rounded-lg bg-[#1B6E4F] flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xs font-heading font-bold">FI</span>
            </div>
            <div className="min-w-0">
              <p className="text-xs font-heading font-bold text-[#3F4A52] truncate leading-tight">{projetoNome}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <ConnectionStatusBadge status={connectionStatus} />
            <GpsStatusBadge status={gpsStatus} precisao={precisaoGps} />
          </div>
        </div>
      </div>
    </header>
  );
}